import { useMemo } from "react";

import { useTranslation } from "next-i18next";

import { useReferralLink } from "@/features/referral-link/hooks/useReferralLink";
import addToast from "@/toast/addToast";

export const useIterbleEmbeddedMessageActions = (): {
  actions: Record<string, () => void>;
} => {
  const { t } = useTranslation();
  const { referralLink } = useReferralLink();

  // These are not URLs we emit — they are the action identifiers Iterable sends
  // in an embedded message's button payload, matched by exact string. They are
  // an external contract, so they must not be derived from `CANONICAL_HOST`:
  // a different configured domain would stop every deep link from resolving.
  const actions = useMemo(
    () => ({
      // eslint-disable-next-line no-restricted-syntax -- external contract, see the note above
      "https://www.whoppah.com/open_download_app_modal": () => {
        import("@/ui/Modal2")
          .then(module => module.showModal("download-app"))
          .catch(ex =>
            console.error("Failed to load 'download-app' modal: ", ex)
          );
      },
      // eslint-disable-next-line no-restricted-syntax -- external contract, see the note above
      "https://www.whoppah.com/copy_referral_link": async () => {
        try {
          await navigator.clipboard.writeText(referralLink);

          addToast(t("common:common-copied-successful"), {
            appearance: "success",
          });
        } catch (ex) {
          console.error(ex);
        }
      },
    }),
    [referralLink, t]
  );

  return { actions };
};
